import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'
import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import TableAAPP from '../../Tables/TableAAPP'
import { useStyles } from '../styles'

const MarkersSubCategorysCard = (props) => {
  const {
    selectedDate,
    totalCategory = [],
    gSubCategoryA,
    gSubCategoryB = [],
  } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Total mercado sub-categoría</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <TableAAPP
              array={totalCategory}
              param="SUBCATEGORIA"
              selectedDate={selectedDate}
              title="sub /cat"
              AA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} lg={6}>
                <h3>Evolución mercado por sub-categorías año</h3>
                <br />
                <Bar
                  data={Utils.barLineDataGroup(gSubCategoryA, 'y', 'y')}
                  options={Utils.optionsGroupedCharts}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={6}>
                <h3>Evolución mercado por sub-categorías mes</h3>
                <br />
                <Bar
                  data={Utils.barLineDataGroup(gSubCategoryB, 'MES', 'NMES')}
                  options={Utils.optionsGroupedCharts}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default MarkersSubCategorysCard
